export function testAutomation(title = ''): string {
    return title.replaceAll(' ', '_');
}
